export function checkForCookieEnabled(){
    var cookieEnabled = window.navigator.cookieEnabled;
    if (!cookieEnabled){ 
        document.cookie = "X-Reycreo-Id";
        cookieEnabled = document.cookie.indexOf("X-Reycreo-Id")!=-1;
    }
    return cookieEnabled;
}


// WEBPACK FOOTER //
// ./src/util/CookieEnable.js